import { action, payload } from "ts-action";
import * as AT from "./actionTypes";

// startImpersonization
export const startImpersonationRequest = action(
  AT.START_IMPERSONATION__REQUEST,
  payload<{ userId: number }>()
);

export const startImpersonationSuccess = action(
  AT.START_IMPERSONATION__SUCCESS,
  payload<{ userId: number }>()
);

export const startImpersonationError = action(
  AT.START_IMPERSONATION__ERROR,
  payload<{ userId: number }>()
);

// Is impersonating
export const isImpersonatingRequest = action(AT.IS_IMPERSONATING__REQUEST);

export const isImpersonatingSuccess = action(
  AT.IS_IMPERSONATING__SUCCESS,
  payload<{ userId: number }>()
);

export const isImpersonatingError = action(AT.IS_IMPERSONATING__ERROR);

// Stop impersonization
export const stopImpersonationRequest = action(AT.STOP_IMPERSONATION__REQUEST);

export const stopImpersonationSuccess = action(AT.STOP_IMPERSONATION__SUCCESS);

export const stopImpersonationError = action(AT.STOP_IMPERSONATION__ERROR);
